import { atom } from "@mongez/react-atom";

type RewardTasksState = {
  unclaimedCount: number;
};

/**
 * Shared unclaimed reward task count used by the hub nav and the header menu.
 *
 * @example
 * const { unclaimedCount } = rewardTasksAtom.useValue();
 */
export const rewardTasksAtom = atom<RewardTasksState>({
  key: "gamificationRewardTasks",
  default: {
    unclaimedCount: 0,
  },
});

/**
 * Store the latest server-confirmed unclaimed reward task count.
 *
 * @example
 * setRewardTasksUnclaimedCount(response.unclaimedCount);
 */
export function setRewardTasksUnclaimedCount(count: number) {
  const safeCount = Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;

  if (rewardTasksAtom.value.unclaimedCount === safeCount) return;

  rewardTasksAtom.change("unclaimedCount", safeCount);
}
